import React from 'react';
import { Navigate } from 'react-router-dom';

const PUBLISHER_JWT_KEY = 'publisher_jwt';

function hasValidPublisherToken() {
  const token = localStorage.getItem(PUBLISHER_JWT_KEY);
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem(PUBLISHER_JWT_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

const PublisherRoute = ({ children }) => {
  if (!hasValidPublisherToken()) return <Navigate to="/publisher/login" replace />;
  return children;
};

export default PublisherRoute;
